import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeAll20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEdgeAll20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.99 3.59a.75.75 0 0 0 0-1.5h-8a.75.75 0 1 0 0 1.5zM2.827 5.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75M17.9 6a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0zm-3.91 11.91a.75.75 0 0 0 0-1.5h-8a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeAll20);
